import CampanaNotificaciones from "./CampanaNotificaciones";
import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState, useEffect } from "react";
import { subirDatos } from './syncSupabase';
import { registrarEvento, EVENTOS } from './Trazabilidad.js';
export function generarOP(lista) {
  const anio = new Date().getFullYear();
  const numero = String(lista.length + 1).padStart(4, "0");
  return `OP-${anio}-${numero}`;
}
function fechaActual() {
  return new Date().toISOString().slice(0, 10);
}
const estadosOT = [
  { valor: "pendiente", label: "⏳ Pendiente", color: "#f59e0b" },
  { valor: "en_proceso", label: "🔵 En proceso", color: "#3b82f6" },
  { valor: "control_calidad", label: "🔍 Control de calidad", color: "#7B5BF2" },
  { valor: "aprobado", label: "✅ Aprobado", color: "#22c55e" },
  { valor: "entregado", label: "📦 Entregado", color: "#808085" },
  { valor: "rechazado", label: "🔴 Rechazado", color: "#e63946" },
];
const estadoColor = { pendiente: "#f59e0b", en_proceso: "#3b82f6", control_calidad: "#7B5BF2", aprobado: "#22c55e", entregado: "#808085", rechazado: "#e63946" };
const estadoLabel = { pendiente: "⏳ Pendiente", en_proceso: "🔵 En proceso", control_calidad: "🔍 Control calidad", aprobado: "✅ Aprobado", entregado: "📦 Entregado", rechazado: "🔴 Rechazado" };
// Fuente de verdad única de los 6 estados reales de una OT (con bg para usar
// en badges tipo pill). Antes Ventas.js mantenía su propia copia con solo 4
// valores — una OT en estado aprobado/entregado/rechazado caía siempre al
// fallback "Pendiente" ahí. Exportado acá para que Ventas.js importe este
// mismo diccionario en vez de duplicarlo.
export const ESTADOS_OT = {
  pendiente:        { label: "Pendiente",         color: "#f59e0b", bg: "#fef3c7" },
  en_proceso:       { label: "En proceso",        color: "#3b82f6", bg: "#dbeafe" },
  control_calidad:  { label: "Control de calidad", color: "#7B5BF2", bg: "#ede9fe" },
  aprobado:         { label: "Aprobado",          color: "#22c55e", bg: "#dcfce7" },
  entregado:        { label: "Entregado",         color: "#808085", bg: "#f3f4f6" },
  rechazado:        { label: "Rechazado",         color: "#e63946", bg: "#fee2e2" },
};
const PROCESOS_CONOCIDOS = [
  "Color CD Frente","Color CD Dorso","Hot Stamping","Poli Mate","Poli Brillo","UV Sectorizado",
  "Gofrado","Relieve","Bajorrelieve","Troquelado","Troquelado Cartón","Entapado","Espelado",
  "Cajonera 1","Cajonera 2","Forrado","Laminado","Montaje","Pegado Manual","Embolsado","Barnizado",
];
const Header = ({ titulo, onBack, extra, navBg }) => (
  <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100, marginBottom: "1.5rem" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <button onClick={onBack} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Volver</button>
      <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>{titulo}</span>
    </div>
    {extra}
  </div>
);
export default function OrdenTrabajo({ onVolver, oscuro, usuario }) {
  const [ots, setOts] = useState([]);
  const [cargandoOts, setCargandoOts] = useState(true);
  useEffect(() => {
    async function cargar() {
      try {
        const { supabase } = await import('./supabase');
        const { data } = await supabase.from('ots').select('data');
        if (data && data.length > 0) setOts(data.map(r => r.data));
        else setOts(JSON.parse(localStorage.getItem('alqos_ots') || '[]'));
      } catch(e) { setOts(JSON.parse(localStorage.getItem('alqos_ots') || '[]')); }
      setCargandoOts(false);
    }
    cargar();
  }, []);
  const [vista, setVista] = useState("listado");
  const [form, setForm] = useState({ estado: "pendiente", fecha: fechaActual() });
  const [otDetalle, setOtDetalle] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(null);
  const [editandoFecha, setEditandoFecha] = useState(false);
  const [nuevaFecha, setNuevaFecha] = useState("");
  const [motivoCambioFecha, setMotivoCambioFecha] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("todos");
  const [tabOT, setTabOT] = useState("listado");
  const [palletsDisponibles, setPalletsDisponibles] = useState([]);
  const [mostrarRepeticionOT, setMostrarRepeticionOT] = useState(false);
  const [busqRepeticionOT, setBusqRepeticionOT] = useState('');
  useEffect(() => {
    const p = JSON.parse(localStorage.getItem("alqos_stock_pallets") || "[]");
    setPalletsDisponibles(p.filter(x => x.estado === "disponible"));
  }, []);
  const bg = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const navBg = oscuro ? "#060f30" : "#09184D";
  const subtexto = oscuro ? "#9aabd4" : "#808085";
  const esAdmin = usuario?.rol === "Administrador";
  const inp = { width: "100%", padding: "8px 12px", borderRadius: "8px", border: `1px solid ${borde}`, fontSize: "13px", boxSizing: "border-box", marginTop: "4px", background: cardBg, color: texto, fontFamily: "sans-serif" };
  const lbl = { fontSize: "12px", color: oscuro ? "#9aabd4" : "#555", fontWeight: "600", display: "block", marginTop: "12px" };
  const card = { background: cardBg, borderRadius: "12px", padding: "1.5rem", border: `1px solid ${borde}`, marginBottom: "12px" };
  const camposOT = [
    { key: "cliente", label: "Cliente" },
    { key: "trabajo", label: "Descripción del trabajo" },
    { key: "codigoProducto", label: "Código de producto" },
    { key: "cantidad", label: "Cantidad" },
    { key: "unidad", label: "Unidad (pliegos / estuches / unidades)" },
    { key: "materialCartulina", label: "Material / Cartulina" },
    { key: "gramaje", label: "Gramaje" },
    { key: "medidaPliego", label: "Medida del pliego" },
    { key: "colores", label: "Colores de impresión" },
    { key: "terminaciones", label: "Terminaciones (troquelado, plastificado, etc.)" },
    { key: "printAprobado", label: "Print aprobado por cliente" },
    { key: "filmAprobado", label: "Film / Película" },
    { key: "muestraAprobada", label: "Muestra aprobada" },
    { key: "observaciones", label: "Observaciones" },
    { key: "fechaEntrega", label: "Fecha de entrega comprometida" },
    { key: "vendedor", label: "Vendedor / Comercial" },
    { key: "cotizacionRef", label: "Referencia de cotización" },
  ];
  if (cargandoOts) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:bg }}>
      <p style={{ color: oscuro?"white":"#09184D", fontSize:"16px" }}>Cargando OTs...</p>
    </div>
  );
  const guardarOT = () => {
    const nueva = {
      ...form,
      id: Date.now(),
      op: generarOP(ots),
      fechaCreacion: new Date().toISOString(),
      creadoPor: usuario?.nombre || "Sistema",
      rolCreador: usuario?.rol || "",
      estado: form.estado || "pendiente",
    };
    if (form.palletVinculado) {
      const pallets = JSON.parse(localStorage.getItem("alqos_stock_pallets") || "[]");
      const actualizados = pallets.map(p => p.codigoPallet === form.palletVinculado ? { ...p, estado: "consumido", otVinculada: nueva.op, fechaConsumo: new Date().toISOString() } : p);
      localStorage.setItem("alqos_stock_pallets", JSON.stringify(actualizados));
      subirDatos("alqos_stock_pallets");
    }
    const nuevasOTs = [...ots, nueva];
    setOts(nuevasOTs);
    localStorage.setItem("alqos_ots", JSON.stringify(nuevasOTs));
    subirDatos("alqos_ots");
    registrarEvento({ tipo: EVENTOS.OT_CREADA, codigo: nueva.op, codigoRelacionado: form.palletVinculado || null, descripcion: "OT creada para " + (nueva.cliente || "sin cliente"), usuario });
    if (form.palletVinculado) {
      registrarEvento({ tipo: EVENTOS.OT_PALLET_VINCULADO, codigo: form.palletVinculado, codigoRelacionado: nueva.op, descripcion: "Pallet vinculado a " + nueva.op, usuario });
    }
    setForm({ estado: "pendiente", fecha: fechaActual() });
    setVista("listado");
  };
  const cambiarEstado = (op, nuevoEstado) => {
    const actualizadas = ots.map(o => o.op === op ? { ...o, estado: nuevoEstado, ultimoCambio: new Date().toISOString(), cambiadoPor: usuario?.nombre } : o);
    setOts(actualizadas);
    localStorage.setItem('alqos_ots', JSON.stringify(actualizadas));
    subirDatos('alqos_ots');
    if (otDetalle?.op === op) setOtDetalle(prev => ({ ...prev, estado: nuevoEstado }));
  };
  const eliminarOT = async (op) => {
    const ot = ots.find(o => o.op === op);
    const nuevasOTs = ots.filter(o => o.op !== op);
    setOts(nuevasOTs);
    localStorage.setItem('alqos_ots', JSON.stringify(nuevasOTs));
    // Borrar de Supabase directo por op si no tiene id
    try {
      const { supabase } = await import('./supabase');
      if (ot?.id) {
        await supabase.from('ots').delete().eq('id', ot.id);
      } else {
        // Buscar por data->>'op'
        const { data } = await supabase.from('ots').select('id, data');
        const row = data?.find(r => r.data?.op === op);
        if (row) await supabase.from('ots').delete().eq('id', row.id);
      }
    } catch(e) { console.error('Error eliminando OT de Supabase:', e); }
    setConfirmEliminar(null);
    setOtDetalle(null);
    setVista("listado");
  };
  const cambiarFechaEntrega = (op, fecha, motivo) => {
    if (!fecha) { alert("Ingresá la nueva fecha."); return; }
    const ot = ots.find(o => o.op === op);
    const entrada = { fechaAnterior: ot?.fechaEntrega||"—", fechaNueva: fecha, motivo: motivo||"Sin motivo", por: usuario?.nombre||"Sistema", fecha: new Date().toISOString() };
    const actualizadas = ots.map(o => o.op === op ? { ...o, fechaEntrega: fecha, historialFechas: [...(o.historialFechas||[]), entrada], ultimoCambio: new Date().toISOString(), cambiadoPor: usuario?.nombre } : o);
    setOts(actualizadas);
    localStorage.setItem("alqos_ots", JSON.stringify(actualizadas));
    subirDatos("alqos_ots");
    if (otDetalle?.op === op) setOtDetalle(prev => ({ ...prev, fechaEntrega: fecha, historialFechas: [...(prev.historialFechas||[]), entrada] }));
    setEditandoFecha(false); setNuevaFecha(""); setMotivoCambioFecha("");
  };
  const actualizarSecuenciaPliego = (op, grupoIdx, pliegoIdx, nuevaSecuencia) => {
    const aplicar = (o) => {
      if (o.op !== op) return o;
      const pliegosTecnicos = (o.pliegosTecnicos||[]).map((grupo, gi) => {
        if (gi !== grupoIdx) return grupo;
        const pliegos = (grupo.pliegos||[]).map((p, pi) => pi === pliegoIdx ? { ...p, secuenciaProcesos: nuevaSecuencia } : p);
        return { ...grupo, pliegos };
      });
      return { ...o, pliegosTecnicos, ultimoCambio: new Date().toISOString(), cambiadoPor: usuario?.nombre };
    };
    const actualizadas = ots.map(aplicar);
    setOts(actualizadas);
    localStorage.setItem('alqos_ots', JSON.stringify(actualizadas));
    subirDatos('alqos_ots');
    if (otDetalle?.op === op) setOtDetalle(prev => aplicar(prev));
  };
  const copiarSecuenciaDeOTAnterior = (otOrigen) => {
    // Match por nombre de pliego (ej. "LAM TAPA"), no por posición, porque
    // distintos trabajos pueden tener distinta cantidad/orden de pliegos.
    const mapaSecuencias = {};
    (otOrigen.pliegosTecnicos || []).forEach(grupo => {
      (grupo.pliegos || []).forEach(p => {
        if (p.nombre && (p.secuenciaProcesos || []).length > 0) {
          mapaSecuencias[p.nombre] = p.secuenciaProcesos;
        }
      });
    });
    const aplicar = (o) => {
      if (o.op !== otDetalle.op) return o;
      const pliegosTecnicos = (o.pliegosTecnicos || []).map(grupo => ({
        ...grupo,
        pliegos: (grupo.pliegos || []).map(p =>
          mapaSecuencias[p.nombre] ? { ...p, secuenciaProcesos: mapaSecuencias[p.nombre] } : p
        ),
      }));
      return { ...o, pliegosTecnicos, ultimoCambio: new Date().toISOString(), cambiadoPor: usuario?.nombre };
    };
    const actualizadas = ots.map(aplicar);
    setOts(actualizadas);
    localStorage.setItem('alqos_ots', JSON.stringify(actualizadas));
    subirDatos('alqos_ots');
    setOtDetalle(prev => aplicar(prev));
    setMostrarRepeticionOT(false);
    setBusqRepeticionOT('');
  };
  const otsFiltradas = filtroEstado === "todos" ? ots : ots.filter(o => o.estado === filtroEstado);
  // eslint-disable-next-line
  if (confirmEliminar) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: cardBg, borderRadius: "16px", padding: "2rem", maxWidth: "360px", width: "90%", border: `1px solid ${borde}`, textAlign: "center" }}>
        <p style={{ fontSize: "32px", marginBottom: "1rem" }}>⚠️</p>
        <p style={{ fontSize: "15px", fontWeight: "600", color: texto, marginBottom: ".5rem" }}>¿Eliminar {confirmEliminar}?</p>
        <p style={{ fontSize: "13px", color: subtexto, marginBottom: "1.5rem" }}>Esta acción no se puede deshacer.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => setConfirmEliminar(null)} style={{ padding: "10px 20px", background: "none", border: `1px solid ${borde}`, borderRadius: "10px", cursor: "pointer", color: texto, fontSize: "13px" }}>Cancelar</button>
          <button onClick={() => eliminarOT(confirmEliminar)} style={{ padding: "10px 20px", background: "#e63946", border: "none", borderRadius: "10px", cursor: "pointer", color: "white", fontSize: "13px", fontWeight: "600" }}>Eliminar</button>
        </div>
      </div>
    </div>
  );
  // eslint-disable-next-line
  if (vista === "detalle" && otDetalle) return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header navBg={navBg} titulo={otDetalle.op}
        onBack={() => { setOtDetalle(null); setVista("listado"); }}
        extra={esAdmin && (
          <button onClick={() => setConfirmEliminar(otDetalle.op)}
            style={{ background: "rgba(230,57,70,.2)", border: "1px solid rgba(230,57,70,.4)", color: "#e63946", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "12px" }}>
            🗑 Eliminar
          </button>
        )}
      />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "10px" }}>Trazabilidad</h3>
          {[["OP", otDetalle.op],["Creado por", `${otDetalle.creadoPor} — ${otDetalle.rolCreador}`],["Fecha de creación", otDetalle.fechaCreacion?.slice(0, 16).replace("T", " ")],["Fecha de entrega", otDetalle.fechaEntrega]].map(([k, v]) => v && (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
              <span style={{ color: subtexto }}>{k}</span>
              <span style={{ color: texto, fontWeight: "500" }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ ...card, border:`1px solid ${oscuro?"#f59e0b44":"#fde68a"}`, background:oscuro?"#1a1000":"#fffbeb" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#f59e0b", margin:0 }}>📅 Fecha de entrega</h3>
            {esAdmin && !editandoFecha && (
              <button onClick={()=>{ setEditandoFecha(true); setNuevaFecha(otDetalle.fechaEntrega||""); }}
                style={{ padding:"4px 10px", background:"#f59e0b15", border:"1px solid #f59e0b40", color:"#f59e0b", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"700" }}>
                ✏️ Cambiar fecha
              </button>
            )}
          </div>
          <div style={{ fontSize:"15px", fontWeight:"700", color: otDetalle.fechaEntrega&&new Date(otDetalle.fechaEntrega)<new Date()&&!["entregado","rechazado"].includes(otDetalle.estado)?"#e63946":"#f59e0b" }}>
            {otDetalle.fechaEntrega||"Sin fecha definida"}
            {otDetalle.fechaEntrega&&new Date(otDetalle.fechaEntrega)<new Date()&&!["entregado","rechazado"].includes(otDetalle.estado)&&(
              <span style={{ marginLeft:"8px", fontSize:"11px", background:"#fee2e2", color:"#e63946", padding:"2px 7px", borderRadius:"6px" }}>⚠️ Vencida</span>
            )}
          </div>
          {editandoFecha&&(
            <div style={{ marginTop:"12px", padding:"12px", background:cardBg, borderRadius:"10px", border:`1px solid ${borde}` }}>
              <p style={{ fontSize:"11px", color:"#f59e0b", fontWeight:"700", margin:"0 0 6px" }}>Nueva fecha</p>
              <input type="date" value={nuevaFecha} onChange={e=>setNuevaFecha(e.target.value)}
                style={{ width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto, boxSizing:"border-box" }}/>
              <p style={{ fontSize:"11px", color:"#f59e0b", fontWeight:"700", margin:"10px 0 6px" }}>Motivo del cambio</p>
              <input value={motivoCambioFecha} onChange={e=>setMotivoCambioFecha(e.target.value)}
                placeholder="Ej: Cliente solicitó postergación..."
                style={{ width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", background:cardBg, color:texto, boxSizing:"border-box" }}/>
              <div style={{ display:"flex", gap:"8px", marginTop:"10px" }}>
                <button onClick={()=>cambiarFechaEntrega(otDetalle.op, nuevaFecha, motivoCambioFecha)}
                  style={{ flex:1, padding:"9px", background:"#f59e0b", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"700", fontSize:"13px" }}>
                  ✅ Confirmar
                </button>
                <button onClick={()=>{ setEditandoFecha(false); setNuevaFecha(""); setMotivoCambioFecha(""); }}
                  style={{ padding:"9px 14px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color:subtexto, fontSize:"13px" }}>
                  Cancelar
                </button>
              </div>
            </div>
          )}
          {(otDetalle.historialFechas||[]).length>0&&(
            <div style={{ marginTop:"10px" }}>
              <p style={{ fontSize:"10px", color:"#f59e0b", fontWeight:"700", textTransform:"uppercase", margin:"0 0 6px" }}>Historial de cambios</p>
              {[...otDetalle.historialFechas].reverse().map((h,i)=>(
                <div key={i} style={{ padding:"5px 0", borderBottom:`0.5px solid ${borde}`, fontSize:"11px" }}>
                  <div style={{ display:"flex", justifyContent:"space-between" }}>
                    <span style={{ color:subtexto }}>{h.fechaAnterior} → <strong style={{ color:"#f59e0b" }}>{h.fechaNueva}</strong></span>
                    <span style={{ color:subtexto }}>{h.por}</span>
                  </div>
                  {h.motivo&&<p style={{ color:subtexto, margin:"2px 0 0", fontStyle:"italic" }}>{h.motivo}</p>}
                </div>
              ))}
            </div>
          )}
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#7B5BF2", marginBottom: "12px" }}>Estado actual</h3>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {estadosOT.map(e => (
              <button key={e.valor} onClick={() => esAdmin && cambiarEstado(otDetalle.op, e.valor)}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: esAdmin ? "pointer" : "default", fontWeight: "600", border: otDetalle.estado === e.valor ? `2px solid ${e.color}` : `1px solid ${borde}`, background: otDetalle.estado === e.valor ? `${e.color}22` : cardBg, color: otDetalle.estado === e.valor ? e.color : subtexto }}>
                {e.label}
              </button>
            ))}
          </div>
          {otDetalle.ultimoCambio && (
            <p style={{ fontSize: "11px", color: subtexto, marginTop: "8px" }}>Último cambio: {otDetalle.ultimoCambio?.slice(0, 16).replace("T", " ")} por {otDetalle.cambiadoPor}</p>
          )}
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", color: "#09184D", marginBottom: "12px" }}>Datos del trabajo</h3>
          {camposOT.map(({ key, label }) => {
            const val = otDetalle[key];
            if (!val) return null;
            return (
              <div key={key} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: `0.5px solid ${borde}`, fontSize: "13px" }}>
                <span style={{ color: subtexto }}>{label}</span>
                <span style={{ color: texto, fontWeight: "500", maxWidth: "55%", textAlign: "right" }}>{val}</span>
              </div>
            );
          })}
        </div>
        {otDetalle.pliegosTecnicos?.length > 0 && (
          <div style={{ ...card, background: oscuro ? "#052e16" : "#f0fdf4", border: `1px solid ${oscuro ? "#22c55e44" : "#bbf7d0"}` }}>
            <h3 style={{ fontSize: "13px", fontWeight: "700", color: "#16a34a", marginBottom: "10px" }}>🧩 Pliegos técnicos (desde Cotización)</h3>
            {esAdmin && (
              <div style={{ marginBottom: "12px" }}>
                {!mostrarRepeticionOT ? (
                  <button onClick={() => setMostrarRepeticionOT(true)}
                    style={{ padding: "6px 12px", background: "none", border: "1px dashed #16a34a", borderRadius: "8px", color: "#16a34a", cursor: "pointer", fontSize: "11px", fontWeight: "600" }}>
                    📋 Copiar secuencia de OT anterior
                  </button>
                ) : (
                  <div style={{ background: cardBg, border: `1px solid ${borde}`, borderRadius: "10px", padding: "10px" }}>
                    <div style={{ display: "flex", gap: "6px", marginBottom: "8px" }}>
                      <input autoFocus placeholder="🔍 Buscar por cliente o trabajo..." value={busqRepeticionOT}
                        onChange={e => setBusqRepeticionOT(e.target.value)}
                        style={{ ...inp, marginTop: 0, flex: 1, fontSize: "12px" }} />
                      <button onClick={() => { setMostrarRepeticionOT(false); setBusqRepeticionOT(''); }}
                        style={{ padding: "7px 10px", borderRadius: "8px", border: `1px solid ${borde}`, background: "none", color: subtexto, cursor: "pointer", fontSize: "12px" }}>✕</button>
                    </div>
                    <div style={{ maxHeight: "160px", overflowY: "auto" }}>
                      {ots
                        .filter(o => o.op !== otDetalle.op && (o.pliegosTecnicos || []).some(g => (g.pliegos || []).some(p => (p.secuenciaProcesos || []).length > 0)))
                        .filter(o => !busqRepeticionOT.trim() || o.cliente?.toLowerCase().includes(busqRepeticionOT.toLowerCase()) || o.trabajo?.toLowerCase().includes(busqRepeticionOT.toLowerCase()) || o.op?.toLowerCase().includes(busqRepeticionOT.toLowerCase()))
                        .slice(0, 20)
                        .map(o => (
                          <div key={o.op} onClick={() => copiarSecuenciaDeOTAnterior(o)}
                            style={{ padding: "8px 10px", borderRadius: "8px", cursor: "pointer", borderBottom: `0.5px solid ${borde}`, fontSize: "12px" }}
                            onMouseEnter={e => e.currentTarget.style.background = oscuro ? "#0d2160" : "#F9FAFB"}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontWeight: "600", color: "#16a34a" }}>{o.op} · {o.cliente || "Sin cliente"}</div>
                            <div style={{ color: subtexto, fontSize: "11px" }}>{o.trabajo || "Sin descripción"}</div>
                          </div>
                        ))}
                      {ots.filter(o => o.op !== otDetalle.op && (o.pliegosTecnicos || []).some(g => (g.pliegos || []).some(p => (p.secuenciaProcesos || []).length > 0))).length === 0 && (
                        <p style={{ fontSize: "12px", color: subtexto, textAlign: "center", padding: "10px" }}>Todavía no hay otra OT con secuencia de procesos cargada.</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {otDetalle.pliegosTecnicos.map((grupo, gi) => (
              <div key={gi} style={{ marginBottom: "16px" }}>
                {grupo.itemDescripcion && (
                  <p style={{ fontSize: "12px", fontWeight: "600", color: texto, marginBottom: "6px" }}>{grupo.itemDescripcion}</p>
                )}
                {(grupo.pliegos || []).map((p, pi) => {
                  const secuencia = p.secuenciaProcesos || [];
                  const setSecuencia = (nueva) => actualizarSecuenciaPliego(otDetalle.op, gi, pi, nueva);
                  const cambiarPaso = (idx, valor) => setSecuencia(secuencia.map((s, i) => i === idx ? valor : s));
                  const quitarPaso = (idx) => setSecuencia(secuencia.filter((_, i) => i !== idx));
                  const agregarPaso = () => setSecuencia([...secuencia, PROCESOS_CONOCIDOS[0]]);
                  return (
                    <div key={pi} style={{ marginBottom: "10px", paddingBottom: "8px", borderBottom: `0.5px solid ${borde}` }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "6px" }}>
                        <span style={{ color: subtexto }}>{p.nombre}</span>
                        <span style={{ color: texto, fontWeight: "500" }}>
                          {p.material} · {p.valor}{p.material === "cartón gris" ? "mm" : (p.material === "papel" || p.material === "cartulina") ? "g" : ""} · {p.bocas} bocas
                          {Number(p.unidades) > 1 ? ` · ${p.unidades}u/estuche` : ""}
                        </span>
                      </div>
                      {esAdmin ? (
                        <div style={{ paddingLeft: "8px" }}>
                          {secuencia.map((paso, idx) => {
                            const esConocido = PROCESOS_CONOCIDOS.includes(paso);
                            return (
                              <div key={idx} style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                                <span style={{ fontSize: "10px", color: subtexto, width: "16px" }}>{idx + 1}.</span>
                                {esConocido ? (
                                  <select value={paso} onChange={e => {
                                    if (e.target.value === "__custom__") cambiarPaso(idx, "");
                                    else cambiarPaso(idx, e.target.value);
                                  }} style={{ ...inp, marginTop: 0, flex: 1, padding: "5px 8px", fontSize: "12px" }}>
                                    {PROCESOS_CONOCIDOS.map(pr => <option key={pr} value={pr}>{pr}</option>)}
                                    <option value="__custom__">✏️ Otro (escribir)</option>
                                  </select>
                                ) : (
                                  <input autoFocus value={paso} placeholder="Escribí el proceso..."
                                    onChange={e => cambiarPaso(idx, e.target.value)}
                                    style={{ ...inp, marginTop: 0, flex: 1, padding: "5px 8px", fontSize: "12px" }} />
                                )}
                                <button onClick={() => quitarPaso(idx)} style={{ background: "none", border: "none", color: "#e63946", cursor: "pointer", fontSize: "14px" }}>×</button>
                              </div>
                            );
                          })}
                          <button onClick={agregarPaso} style={{ marginTop: "4px", padding: "4px 10px", background: "none", border: `1px dashed ${borde}`, borderRadius: "8px", color: "#16a34a", cursor: "pointer", fontSize: "11px", fontWeight: "600" }}>+ Agregar proceso</button>
                        </div>
                      ) : (
                        secuencia.length > 0 && (
                          <p style={{ fontSize: "11px", color: subtexto, paddingLeft: "8px" }}>{secuencia.join(" → ")}</p>
                        )
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        )}
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#fff8f0", border: `1px solid ${oscuro ? "#f59e0b44" : "#fde68a"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#f59e0b", marginBottom: "8px" }}>Herramental de control</h3>
          {[["Print aprobado", otDetalle.printAprobado],["Film / Película", otDetalle.filmAprobado],["Muestra aprobada", otDetalle.muestraAprobada]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", padding: "4px 0", borderBottom: `0.5px solid ${borde}` }}>
              <span style={{ color: subtexto }}>{k}</span>
              <span style={{ color: texto, fontWeight: "500" }}>{v || "—"}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
  // eslint-disable-next-line
  if (vista === "nueva") return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <Header navBg={navBg} titulo="Nueva Orden de Trabajo" onBack={() => setVista("listado")} />
      <div style={{ padding: "0 2rem 2rem", maxWidth: "700px", margin: "0 auto" }}>
        <div style={{ ...card, background: oscuro ? "#0a1f5c" : "#F0EEFF", border: `1px solid ${oscuro ? "#7B5BF2" : "#d4c8ff"}` }}>
          <h3 style={{ fontSize: "13px", fontWeight: "600", color: "#7B5BF2", marginBottom: "4px" }}>Trazabilidad automática</h3>
          <p style={{ fontSize: "12px", color: subtexto, margin: 0 }}>Creado por: <strong style={{ color: texto }}>{usuario?.nombre}</strong> — {usuario?.rol}</p>
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Identificación</h3>
          <span style={lbl}>Fecha</span>
          <input type="date" defaultValue={fechaActual()} onChange={e => setForm(f => ({ ...f, fecha: e.target.value }))} style={inp} />
          <span style={lbl}>Estado inicial</span>
          <div style={{ display: "flex", gap: "8px", marginTop: "6px", flexWrap: "wrap" }}>
            {estadosOT.slice(0, 2).map(e => (
              <button key={e.valor} onClick={() => setForm(f => ({ ...f, estado: e.valor }))}
                style={{ padding: "7px 12px", borderRadius: "10px", fontSize: "12px", cursor: "pointer", fontWeight: "600", border: form.estado === e.valor ? `2px solid ${e.color}` : `1px solid ${borde}`, background: form.estado === e.valor ? `${e.color}22` : cardBg, color: form.estado === e.valor ? e.color : texto }}>
                {e.label}
              </button>
            ))}
          </div>
        <div style={{...card, border:"1px solid #7B5BF240", background: oscuro?"#0a1f5c":"#f5f3ff"}}>
          <h3 style={{fontSize:"14px", fontWeight:"600", marginBottom:"8px", color:"#7B5BF2"}}>🏷️ Material vinculado (opcional)</h3>
          <span style={lbl}>Pallet / unidad de stock a consumir</span>
          <select value={form.palletVinculado || ""} onChange={e => setForm(f => ({...f, palletVinculado: e.target.value}))} style={inp}>
            <option value="">— Sin vincular —</option>
            {palletsDisponibles.map(p => (
              <option key={p.codigoPallet} value={p.codigoPallet}>
                {p.codigoPallet} · {p.tipoMaterial} · {p.cantidadActual} {p.unidad}{p.gramaje ? " · " + p.gramaje + "g/m2" : ""}{p.esFSC ? " · FSC" : ""}
              </option>
            ))}
          </select>
          {form.palletVinculado && <p style={{fontSize:"11px", color:"#22c55e", marginTop:"6px", fontFamily:"monospace"}}>✓ Al guardar, el pallet pasará a estado "consumido"</p>}
          {palletsDisponibles.length === 0 && <p style={{fontSize:"11px", color:"#f59e0b", marginTop:"6px"}}>No hay pallets disponibles. Registrá primero un ingreso de material.</p>}
        </div>
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Datos del trabajo</h3>
          {camposOT.slice(0, 10).map(({ key, label }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              <input onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />
            </div>
          ))}
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#f59e0b" }}>Herramental de control</h3>
          {camposOT.slice(10, 13).map(({ key, label }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              <input onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} placeholder="Número / referencia / versión" />
            </div>
          ))}
        </div>
        <div style={card}>
          <h3 style={{ fontSize: "14px", fontWeight: "600", marginBottom: "8px", color: "#09184D" }}>Cierre y entrega</h3>
          {camposOT.slice(13).map(({ key, label }) => (
            <div key={key}>
              <span style={lbl}>{label}</span>
              <input type={key === "fechaEntrega" ? "date" : "text"} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} style={inp} />
            </div>
          ))}
        </div>
        <button onClick={guardarOT} style={{ width: "100%", padding: "14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: "pointer", marginTop: "1rem" }}>
          Guardar Orden de Trabajo
        </button>
      </div>
    </div>
  );
  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "sans-serif" }}>
      <div style={{ background: navBg, padding: "1rem 1.5rem", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={onVolver} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "white", padding: "6px 14px", borderRadius: "10px", cursor: "pointer", fontSize: "13px" }}>← Menú</button>
          <BotonInstructivo moduloKey="ots" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="ots" oscuro={oscuro} />}
          <span style={{ color: "white", fontWeight: "700", fontSize: "16px" }}>Órdenes de Trabajo</span>
        </div>
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <button onClick={() => setTabOT("listado")} style={{ padding: "5px 12px", background: tabOT==="listado"?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.08)", border: "none", color: "white", borderRadius: "8px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>📋 Lista</button>
          <button onClick={() => setTabOT("gantt")} style={{ padding: "5px 12px", background: tabOT==="gantt"?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.08)", border: "none", color: "white", borderRadius: "8px", cursor: "pointer", fontSize: "12px", fontWeight: "600" }}>📅 Gantt</button>
          <CampanaNotificaciones oscuro={oscuro} modulo="OT" />
          <button onClick={() => setVista("nueva")} style={{ padding: "6px 14px", background: "#7B5BF2", color: "white", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>+ Nueva OT</button>
        </div>
      </div>
      <div style={{ padding: "1rem 1.5rem" }}>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "1rem" }}>
          <button onClick={() => setFiltroEstado("todos")}
            style={{ padding: "5px 12px", borderRadius: "20px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === "todos" ? "2px solid #7B5BF2" : `1px solid ${borde}`, background: filtroEstado === "todos" ? "rgba(123,91,242,.1)" : cardBg, color: filtroEstado === "todos" ? "#7B5BF2" : subtexto }}>
            Todas ({ots.length})
          </button>
          {estadosOT.map(e => {
            const cant = ots.filter(o => o.estado === e.valor).length;
            if (cant === 0) return null;
            return (
              <button key={e.valor} onClick={() => setFiltroEstado(e.valor)}
                style={{ padding: "5px 12px", borderRadius: "20px", fontSize: "11px", cursor: "pointer", fontWeight: "600", border: filtroEstado === e.valor ? `2px solid ${e.color}` : `1px solid ${borde}`, background: filtroEstado === e.valor ? `${e.color}22` : cardBg, color: filtroEstado === e.valor ? e.color : subtexto }}>
                {e.label} ({cant})
              </button>
            );
          })}
        </div>
        {tabOT === "gantt" && (() => {
          const hoy = new Date();
          const otsConFecha = ots.filter(o => o.fechaEntrega && o.fecha);
          if (otsConFecha.length === 0) return (
            <div style={{ textAlign:"center", padding:"3rem", color: subtexto }}>
              <p style={{ fontSize:"32px" }}>📅</p>
              <p style={{ fontSize:"14px" }}>No hay OTs con fecha de inicio y entrega para mostrar en Gantt</p>
            </div>
          );
          const fechas = otsConFecha.flatMap(o => [new Date(o.fecha), new Date(o.fechaEntrega)]);
          const minFecha = new Date(Math.min(...fechas));
          const maxFecha = new Date(Math.max(...fechas));
          minFecha.setDate(minFecha.getDate() - 1);
          maxFecha.setDate(maxFecha.getDate() + 2);
          const totalDias = Math.ceil((maxFecha - minFecha) / 86400000);
          const pct = (fecha) => ((new Date(fecha) - minFecha) / (maxFecha - minFecha)) * 100;
          const hoyPct = ((hoy - minFecha) / (maxFecha - minFecha)) * 100;
          return (
            <div style={{ overflowX: "auto" }}>
              <div style={{ minWidth: "600px", padding: "0 0 1rem" }}>
                {/* Cabecera fechas */}
                <div style={{ position: "relative", height: "24px", marginBottom: "8px", marginLeft: "140px" }}>
                  {Array.from({ length: totalDias }).map((_, i) => {
                    const d = new Date(minFecha); d.setDate(d.getDate() + i);
                    if (d.getDate() !== 1 && i !== 0 && i % Math.max(1, Math.floor(totalDias/8)) !== 0) return null;
                    const left = (i / totalDias) * 100;
                    return <span key={i} style={{ position:"absolute", left:`${left}%`, fontSize:"9px", color:subtexto, transform:"translateX(-50%)" }}>{d.toLocaleDateString("es-AR",{day:"2-digit",month:"2-digit"})}</span>;
                  })}
                </div>
                {/* Barras */}
                {otsConFecha.map(ot => {
                  const inicio = pct(ot.fecha);
                  const fin = pct(ot.fechaEntrega);
                  const ancho = Math.max(fin - inicio, 1);
                  const vencida = new Date(ot.fechaEntrega) < hoy && !["entregado","rechazado"].includes(ot.estado);
                  const color = vencida ? "#e63946" : estadoColor[ot.estado] || "#7B5BF2";
                  return (
                    <div key={ot.op} style={{ display:"flex", alignItems:"center", marginBottom:"8px", gap:"8px" }}
                      onClick={() => { setOtDetalle(ot); setVista("detalle"); }}>
                      <div style={{ width:"132px", flexShrink:0, fontSize:"11px", fontWeight:"600", color:texto, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", cursor:"pointer" }} title={`${ot.op} — ${ot.cliente||""}`}>
                        {ot.op} {ot.cliente ? `· ${ot.cliente.slice(0,12)}` : ""}
                      </div>
                      <div style={{ flex:1, position:"relative", height:"26px", background: oscuro?"#0d2160":"#f0eeff", borderRadius:"4px" }}>
                        <div style={{ position:"absolute", left:`${inicio}%`, width:`${ancho}%`, height:"100%", background:color, borderRadius:"4px", opacity:0.85, cursor:"pointer", display:"flex", alignItems:"center", paddingLeft:"6px", overflow:"hidden" }}>
                          <span style={{ fontSize:"10px", color:"white", fontWeight:"600", whiteSpace:"nowrap" }}>{ot.trabajo?.slice(0,20)||ot.op}</span>
                        </div>
                        {/* Línea hoy */}
                        {hoyPct >= 0 && hoyPct <= 100 && (
                          <div style={{ position:"absolute", left:`${hoyPct}%`, top:0, bottom:0, width:"2px", background:"#e63946", zIndex:2 }}/>
                        )}
                      </div>
                      <span style={{ fontSize:"10px", fontWeight:"700", color, flexShrink:0, width:"60px" }}>{estadoLabel[ot.estado]?.split(" ")[1]||ot.estado}</span>
                    </div>
                  );
                })}
                {/* Leyenda línea hoy */}
                <div style={{ display:"flex", alignItems:"center", gap:"6px", marginTop:"8px", marginLeft:"140px" }}>
                  <div style={{ width:"16px", height:"2px", background:"#e63946" }}/>
                  <span style={{ fontSize:"10px", color:subtexto }}>Hoy — {hoy.toLocaleDateString("es-AR")}</span>
                </div>
              </div>
            </div>
          );
        })()}
        {tabOT === "listado" && otsFiltradas.length === 0
          ? <div style={{ textAlign: "center", padding: "4rem", color: "#aaa" }}>
              <p style={{ fontSize: "40px" }}>📋</p>
              <p style={{ fontSize: "15px", color: texto }}>No hay órdenes de trabajo aún</p>
              <p style={{ fontSize: "13px" }}>Hacé clic en "+ Nueva OT" para comenzar</p>
            </div>
          : tabOT === "listado" ? otsFiltradas.map(ot => (
              <div key={ot.op} onClick={() => { setOtDetalle(ot); setVista("detalle"); }}
                style={{ background: cardBg, borderRadius: "12px", padding: "1.2rem 1.5rem", border: `1px solid ${borde}`, marginBottom: "10px", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(123,91,242,0.15)"}
                onMouseLeave={e => e.currentTarget.style.boxShadow = "none"}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div>
                    <span style={{ fontWeight: "700", color: "#7B5BF2", fontSize: "14px" }}>{ot.op}</span>
                    <span style={{ marginLeft: "10px", fontSize: "13px", color: texto, fontWeight: "600" }}>{ot.cliente || "Sin cliente"}</span>
                    <p style={{ fontSize: "12px", color: subtexto, marginTop: "4px" }}>{ot.trabajo || "Sin descripción"}</p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                    <span style={{ fontSize: "11px", fontWeight: "700", color: estadoColor[ot.estado] || "#808085" }}>{estadoLabel[ot.estado] || "—"}</span>
                    <span style={{ fontSize: "11px", color: subtexto }}>{ot.fechaEntrega ? `Entrega: ${ot.fechaEntrega}` : ""}</span>
                  </div>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: oscuro ? "#7B5BF2" : "#9b8cc4" }}>
                  {ot.cantidad && `${ot.cantidad} ${ot.unidad || ""} · `}Creado por: {ot.creadoPor}
                </div>
              </div>
            )) : null
        }
      </div>
    </div>
  );
}
